import _ from 'lodash'
import calendars from 'scoreboard/components/calendars'
import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import prettyJoiner from 'scoreboard/reports/common/filter/pretty-joiner'
import MultichoiceFilter from 'scoreboard/reports/common/filter/multichoice-filter'
import multichoiceTemplate from 'scoreboard/reports/common/filter/multichoice-filter.hbs'
import dropdown from 'scoreboard/components/dropdown'

function meta(code, form, options) {
	return _.defaults({
		nameCode: code,
		filterType: 'id',
		form: form,
		dialogType: 'dark',
		groupCode: 'admin.scorecards.metric.scoringType.basic'
	}, options || {})
}

// the only difference in id filters & multichoice filters is that the values
// of the values are ids from objects in scoreboard, as oppose to a finite
// constant set of values.  Aside from that ids filters behave the exact way
// allowing users to choose zero or more values

var IdFilterMeta = {
	nativeCalendarIds: _.defaults(meta('report.customReport.nativeCalendar', MultichoiceFilter), {
		classes: 'report-native-calendar',
		template: multichoiceTemplate,
		choices: function() {
			return calendars.calendars
		},
		pluralLabel: () => i18n.get('common.calendar.calendars')
	}),
	scoringTypeIds: _.defaults(meta('report.customReport.scoringType', MultichoiceFilter), {
		classes: 'report-scoring-type',
		template: multichoiceTemplate,
		choices: () => dropdown.scoringTypeOptions(),
		stringify: function(data) {
			var labels = _(config.scoringTypes).keyBy('id').at(data.values).map('label').map(function(v){
				return i18n.get(v)
			}).value()
			return i18n.get('report.filter.pretty.multichoice', prettyJoiner(labels))
		},
		pluralLabel: () => i18n.get('admin.appConfiguration.scoringTypes')
	})
}

export default IdFilterMeta

IdFilterMeta.__filename__ = 'reports/wizard/filter-meta/id-filter-meta.js'
